import {EntitySureFlowLoop} from './entity-sure-flow-loop';
import {SureFlowEntityUnitRatingInput} from './sure-flow-entity-unit-rating-input';
import {SpecificationCharacteristic} from '../entity/specification-characteristic';

export class SureFlowEntityRatingInput {

  loop!: EntitySureFlowLoop;
  units!: SureFlowEntityUnitRatingInput[];
  updatedCharacteristics!: SpecificationCharacteristic[];
  engineKey!: string;
  updateUser!: string;

}
